import type { Presentation } from '../../types';
import { DeepLinkCta } from './DeepLinkCta';

interface Props {
  p: Extract<Presentation, { type: 'prose' }>;
}

// The prose itself lives in AssistantMessage above the presentation; this
// component is the empty-card form rendered when no structured envelope was
// produced. Its job is mostly to surface the CTA when present.
export function ProsePresentation({ p }: Props) {
  if (!p.cta) return null;
  return (
    <div className="presentation-card presentation-card--prose">
      <DeepLinkCta cta={p.cta} />
    </div>
  );
}
